<div style="padding: 20px 10px 0px 20px;">
  <h1 class="mat-display-1" style="margin-bottom: 20px;">Fournisseurs de matériel lié au COVID</h1>
</div>

<div style="display: flex; flex-wrap: wrap; justify-content: space-evenly; align-items: stretch;">
  <div class="stand-card" style="flex-grow: 1; margin: 10px; min-width: 310px; max-width: 340px;">
    <mat-card style="min-width: 310px; max-width: 310px;">
      <mat-card-header>
        <mat-card-title>Extruflex</mat-card-title>
        <mat-card-subtitle>25 rue Greffulhe, 92300 Levallois-Perret</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <p>Fabrique des écrans de protection pour les comptoirs et les caisses afin de protéger les commerçants des postillons.</p>
        <p>Les écrans sont en PVC souple sans phthalate, nettoyable avec de l’eau savonneuse. Les armatures sont en aluminium et se suspendent au plafond grâce à un filin métallique.</p>

        <mat-list dense>
          <mat-list-item>
            <mat-icon matListIcon style="color: #2E3D99">contacts</mat-icon>
            <h3 matLine>Gwénaël Le Mouël</h3>
          </mat-list-item>
          <mat-list-item>
            <mat-icon matListIcon style="color: #2E3D99">call</mat-icon>
            <h3 matLine><a href="tel:+33141499933">+33 1 41 49 99 33</a></h3>
          </mat-list-item>
          <mat-list-item>
            <mat-icon matListIcon style="color: #2E3D99">email</mat-icon>
            <h3 matLine><a href="mailto:g.lemouel@extruflex.com">g.lemouel@extruflex.com</a></h3>
          </mat-list-item>
          <mat-list-item>
            <mat-icon matListIcon style="color: #2E3D99">language</mat-icon>
            <h3 matLine><a href="https://www.extruflex.com" target="_blank">https://www.extruflex.com</a></h3>
          </mat-list-item>
        </mat-list>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="stand-card" style="flex-grow: 1; margin: 10px; min-width: 310px; max-width: 340px;">
    <mat-card style="min-width: 310px; max-width: 310px;">
      <mat-card-header>
        <mat-card-title>NH&R</mat-card-title>
        <mat-card-subtitle>76 rue Jules Guesde, 92300 Levallois-Perret</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <p>Vends des masques de protection pour adultes et enfants, des masques à visières transparentes et des gants.</p>

        <mat-list dense>
          <mat-list-item>
            <mat-icon matListIcon style="color: #2E3D99">call</mat-icon>
            <h3 matLine><a href="tel:+33624722501">+33 6 24 72 25 01</a></h3>
          </mat-list-item>
          <mat-list-item>
            <mat-icon matListIcon style="color: #2E3D99">email</mat-icon>
            <h3 matLine><a href="mailto:contact@nhrfrance.fr">contact@nhrfrance.fr</a></h3>
          </mat-list-item>
          <mat-list-item>
            <mat-icon matListIcon style="color: #2E3D99">language</mat-icon>
            <h3 matLine><a href="https://nhrfrance.fr/fr/" target="_blank">https://nhrfrance.fr/fr/</a></h3>
          </mat-list-item>
        </mat-list>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="stand-card" style="flex-grow: 1; margin: 10px; min-width: 310px; max-width: 340px;">
    <mat-card style="min-width: 310px; max-width: 310px;">
      <mat-card-header>
        <mat-card-title>LD</mat-card-title>
        <mat-card-subtitle>35 Rue Chaptal, 92300 Levallois-Perret</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <p>Vends des masques chirurgicaux, lavables, visières, avec minimum de quantités</p>

        <mat-list dense>
          <mat-list-item>
            <mat-icon matListIcon style="color: #2E3D99">contacts</mat-icon>
            <h3 matLine>Fabien Sfez</h3>
          </mat-list-item>
          <mat-list-item>
            <mat-icon matListIcon style="color: #2E3D99">call</mat-icon>
            <h3 matLine><a href="tel:+33613028394">+33 6 13 02 83 94</a></h3>
          </mat-list-item>
        </mat-list>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="stand-card" style="flex-grow: 1; margin: 10px; min-width: 310px; max-width: 340px;">
    <mat-card style="min-width: 310px; max-width: 310px;">
      <mat-card-header>
        <mat-card-title>Societe distri Europe</mat-card-title>
        <!-- <mat-card-subtitle>Fabrication avec imprimante 3D</mat-card-subtitle> -->
      </mat-card-header>
      <mat-card-content>
        <p>Vente de masques de protection pour adultes et enfants</p>

        <mat-list dense>
          <mat-list-item>
            <mat-icon matListIcon style="color: #2E3D99">contacts</mat-icon>
            <h3 matLine>Quentin vaidis</h3>
          </mat-list-item>
          <mat-list-item>
            <mat-icon matListIcon style="color: #2E3D99">call</mat-icon>
            <h3 matLine><a href="tel:+33615021666">+33 6 15 02 16 66</a></h3>
          </mat-list-item>
        </mat-list>
      </mat-card-content>
    </mat-card>
  </div>

  <!-- <div class="stand-card" style="flex-grow: 1; margin: 10px; min-width: 310px; max-width: 340px;">
    <mat-card style="min-width: 310px; max-width: 310px;">
      <mat-card-header>
        <mat-card-title>Dérobert Côme</mat-card-title>
        <mat-card-subtitle>Fabrication avec imprimante 3D</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <p>Visières 7€ à l'unité et 5€ pour une clé à l'unité</p>

        <mat-list dense>
          <mat-list-item>
            <mat-icon matListIcon style="color: #2E3D99">contacts</mat-icon>
            <h3 matLine>Dérobert Côme</h3>
          </mat-list-item>
          <mat-list-item>
            <mat-icon matListIcon style="color: #2E3D99">call</mat-icon>
            <h3 matLine><a href="tel:+33658137277">+33 6 58 13 72 77</a></h3>
          </mat-list-item>
          <mat-list-item>
            <mat-icon matListIcon style="color: #2E3D99">email</mat-icon>
            <h3 matLine><a href="mailto:come.derobert@gmail.com">come.derobert@gmail.com</a></h3>
          </mat-list-item>
        </mat-list>
      </mat-card-content>
    </mat-card>
  </div> -->
</div>